import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Menu from './components/Menu';
import Builder from './components/Builder';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Toast from './components/Toast';

function App() {
  return (
    <div className="bg-white text-brand-800 font-sans smooth-scroll antialiased selection:bg-brand-100 selection:text-brand-900">
      <Toast />
      <Header />
      <Hero />
      <Menu />
      <About />
      <Builder />
      <Testimonials />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;
